module.exports = __webpack_public_path__ + "img/95A.815190f6.png";